
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {installThemeToggle, installHashImport} = await import("./lib/helpers.js").then((module) => {
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImport" in module)) throw new SyntaxError(`export 'installHashImport' not found`);
  return module;
});
installThemeToggle({ html, display });
const imported = installHashImport();
if (imported) {
  display(html`<div class="feedback feedback-info">
    ✅ Lösungen aus dem Link wurden geladen. Klick auf eine Übung, um deinen Fortschritt zu sehen.
  </div>`);
}
return {installThemeToggle,installHashImport,imported};
},
    inputs: ["html","display"],
    outputs: ["installThemeToggle","installHashImport","imported"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: async (html,display) => {
const {downloadAsFile, importFromFile, exportAll} = await import("./lib/progress.js").then((module) => {
  if (!("downloadAsFile" in module)) throw new SyntaxError(`export 'downloadAsFile' not found`);
  if (!("importFromFile" in module)) throw new SyntaxError(`export 'importFromFile' not found`);
  if (!("exportAll" in module)) throw new SyntaxError(`export 'exportAll' not found`);
  return module;
});

function makeButton(label, onClick) {
  const btn = html`<button style="
    font: 500 14px/1 var(--sans-serif);
    padding: .55em 1em;
    border: 1px solid var(--theme-foreground-faintest);
    border-radius: .4em;
    background: var(--theme-background);
    color: var(--theme-foreground);
    cursor: pointer;
    margin-right: .5em;
  ">${label}</button>`;
  btn.addEventListener("click", onClick);
  return btn;
}

const status = html`<div style="margin-top:.6em;min-height:1.5em"></div>`;

function setStatus(node) {
  status.innerHTML = "";
  if (node) status.appendChild(node);
}

const downloadBtn = makeButton("💾 Lösungen herunterladen", () => {
  if (Object.keys(exportAll()).length === 0) {
    setStatus(html`<div style="color:var(--theme-foreground-muted)">Du hast noch keine Lösungen — bearbeite erst eine Übung.</div>`);
    return;
  }
  downloadAsFile();
  setStatus(html`<div class="feedback feedback-ok" style="display:inline-block">✅ <code>fortschritt.json</code> heruntergeladen — schick uns die Datei per Mail oder Discord.</div>`);
});

const fileInput = html`<input type="file" accept=".json,application/json" style="display:none">`;
fileInput.addEventListener("change", async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  try {
    const data = await importFromFile(file);
    setStatus(html`<div class="feedback feedback-ok" style="display:inline-block">✅ ${Object.keys(data).length} Einträge importiert. Lade eine Übungs-Seite, um deine Lösungen zu sehen.</div>`);
  } catch (err) {
    setStatus(html`<div class="feedback feedback-err" style="display:inline-block">❌ Datei konnte nicht gelesen werden: ${err.message}</div>`);
  }
});

const importFileBtn = makeButton("📂 Lösungen importieren", () => fileInput.click());

display(html`<div style="margin:.5em 0">
  <div style="margin-bottom:.5em">${downloadBtn}${importFileBtn}${fileInput}</div>
  ${status}
</div>`);
return {downloadAsFile,importFromFile,exportAll,makeButton,status,setStatus,downloadBtn,fileInput,importFileBtn};
},
    inputs: ["html","display"],
    outputs: ["downloadAsFile","importFromFile","exportAll","makeButton","status","setStatus","downloadBtn","fileInput","importFileBtn"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
